import { render, staticRenderFns } from "./invoice-overview-searchbar.vue?vue&type=template&id=2080fbf2&scoped=true&"
import script from "./invoice-overview-searchbar.vue?vue&type=script&lang=ts&"
export * from "./invoice-overview-searchbar.vue?vue&type=script&lang=ts&"
import style0 from "./invoice-overview-searchbar.vue?vue&type=style&index=0&id=2080fbf2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2080fbf2",
  null
  
)

export default component.exports